import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, FormMessage, Accordion, Button, Grid, HintView } from "lib/components/index";

import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { ProductPickupPointDecorator, ProductLocationDecorator } from "lib/decorators/index";
import { stateSelector, updateProduct, validate, save } from "../index";
import Hint from "./StepLocationHint";
import ProductPickupPointFormSection from "./ProductPickupPointFormSection";
import ProductLocationFormSection from "./ProductLocationFormSection";

class ProductVariantPickupsFormSection extends React.PureComponent {
  state = {
    newPickupPoint: null,
    editedPickupPointUuid: null,
  };

  _buildNewProductPickupPoint(attributes = {}) {
    const { product_variant } = this.props;
    return ProductPickupPointDecorator.build({
      position: Math.max(0, ...product_variant.product_pickup_points.map((x) => x.position)) + 1,
      ...attributes,
    });
  }

  handlePropChange(prop, value) {
    const { product_variant, onChange } = this.props;
    onChange({
      ...product_variant,
      [prop]: value,
    });
  }

  handleTranslationPropChange(prop, value) {
    const { product_variant, editedLocale, onChange } = this.props;
    onChange({
      ...product_variant,
      translations: product_variant.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([{ ...product_variant.getTranslation(editedLocale), [prop]: value }]),
    });
  }

  handleProductPickupPointChange(product_pickup_point) {
    const { product_variant, onChange } = this.props;

    let product_pickup_points;
    if (product_pickup_point._new) {
      product_pickup_points = [
        ...product_variant.product_pickup_points,
        {
          ...product_pickup_point,
          _new: undefined,
          _focus: undefined,
        },
      ];
      this.setState({ newPickupPoint: null });
    } else {
      product_pickup_points = product_variant.product_pickup_points.map((x) =>
        x.uuid === product_pickup_point.uuid ? product_pickup_point : x
      );
    }

    onChange({
      ...product_variant,
      product_pickup_points,
    });
  }

  handleProductPickupPointRemove(product_pickup_point) {
    const { product_variant, onChange, onBlur } = this.props;
    const product_pickup_points = product_variant.product_pickup_points.filter(
      (x) => x.uuid !== product_pickup_point.uuid
    );
    onChange({
      ...product_variant,
      product_pickup_points,
    });
    onBlur();
  }

  handleNewPickupPointClick() {
    if (this.state.newPickupPoint && this.state.newPickupPoint.uuid === this.state.editedPickupPointUuid) {
      this.setState({ editedPickupPointUuid: null });
    } else {
      const newPickupPoint = this._buildNewProductPickupPoint({
        _new: true,
        _focus: true,
      });
      this.setState({
        newPickupPoint,
        editedPickupPointUuid: newPickupPoint.uuid,
      });
    }
  }

  render() {
    const { readOnlyAccess, product_variant, editedLocale, product_price_currency, errors, name, onBlur, onChange } =
      this.props;

    const editedPickupPoint =
      this.state.editedPickupPointUuid &&
      product_variant.product_pickup_points
        .concat(this.state.newPickupPoint ? [this.state.newPickupPoint] : [])
        .find((point) => point.uuid === this.state.editedPickupPointUuid);

    return (
      <div>
        {!!errors[name] && <FormMessage error={errors[name]} />}

        <Grid columns={2}>
          <Grid.Column>
            <div className="ui feed pickups">
              {product_variant &&
                product_variant.product_pickup_points.map((product_pickup_point) => (
                  <div
                    className={classNames("event", {
                      error: !errors.hasValidProp(`${name}.product_pickup_points[${product_pickup_point.uuid}]`),
                    })}
                    key={product_pickup_point.uuid}
                    onClick={() =>
                      !readOnlyAccess &&
                      this.setState({
                        editedPickupPointUuid: product_pickup_point.uuid,
                      })
                    }
                  >
                    <div className="content left">
                      {product_pickup_point.departure_time && (
                        <div className="time departure">
                          <label>{I18n.humanAttributeName("product_pickup_point", "departure_time")}</label>{" "}
                          {product_pickup_point.departure_time}
                        </div>
                      )}
                      {product_pickup_point.arrival_time && (
                        <div className="time arrival">
                          <label>{I18n.humanAttributeName("product_pickup_point", "arrival_time")}</label>{" "}
                          {product_pickup_point.arrival_time}
                        </div>
                      )}
                    </div>
                    <div className="label">
                      <i className="icon material-icons">location_on</i>
                    </div>
                    <div className="content right">
                      <div className="pickup-name">
                        {product_pickup_point.location_name || I18n.t("papp.common.no_name")}
                        {!!(product_pickup_point.additional_fee && product_pickup_point.additional_fee.value) &&
                          ` (${st.formatMoney(product_pickup_point.additional_fee)})`}
                        &nbsp;
                        <a className="ui button basic link icon">
                          <i className="icon material-icons">edit</i>
                        </a>
                      </div>
                      <div className="pickup-additional_instructions">
                        {product_pickup_point.additional_instructions}
                      </div>
                    </div>
                  </div>
                ))}
              {product_variant.allow_custom_pickup_point && (
                <div className="event">
                  <div className="content left"></div>
                  <div className="label">
                    <i className="icon material-icons">location_on</i>
                  </div>
                  <div className="content right">
                    <div className="pickup-name">
                      {I18n.t("papp.products.EditProductView.StepLocation.custom_pickup_point_name")}
                      {!!(
                        product_variant.custom_pickup_point_additional_fee &&
                        product_variant.custom_pickup_point_additional_fee.value
                      ) && ` (${st.formatMoney(product_variant.custom_pickup_point_additional_fee)})`}
                    </div>
                  </div>
                </div>
              )}
              {product_variant.allow_no_pickup_point && (
                <div className="event">
                  <div className="content left"></div>
                  <div className="label">
                    <i className="icon material-icons">location_on</i>
                  </div>
                  <div className="content right">
                    <div className="pickup-name">
                      {I18n.t("papp.products.EditProductView.StepLocation.no_pickup_point_name")}
                    </div>
                  </div>
                </div>
              )}
              <div className="event new" onClick={() => !readOnlyAccess && this.handleNewPickupPointClick()}>
                <div className="content left"></div>
                <div className="label">
                  <i className="icon material-icons">add_location</i>
                </div>
                <div className="content right">
                  <a className="ui button blue basic link pickup-new-link">
                    {I18n.t("papp.products.EditProductView.StepLocation.add_new_pickup_point")}
                  </a>
                </div>
              </div>
            </div>
          </Grid.Column>

          <Grid.Column>
            <FormControl.CheckboxFormGroup
              {...FormControl.addProps(`${name}.allow_custom_pickup_point`, {
                errors,
              })}
              value={product_variant.allow_custom_pickup_point}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "allow_custom_pickup_point")}
              label={I18n.humanAttributeName("product_variant", "allow_custom_pickup_point")}
              toggle
              readOnly={readOnlyAccess}
            />

            {product_variant.allow_custom_pickup_point && (
              <FormControl.MoneyFormGroup
                {...FormControl.addProps(`${name}.custom_pickup_point_additional_fee`, { errors })}
                value={product_variant.custom_pickup_point_additional_fee}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "custom_pickup_point_additional_fee")}
                label={I18n.humanAttributeName("product_variant", "custom_pickup_point_additional_fee")}
                defaultCurrency={product_price_currency}
                readOnly={readOnlyAccess}
              />
            )}

            <FormControl.CheckboxFormGroup
              {...FormControl.addProps(`${name}.allow_no_pickup_point`, {
                errors,
              })}
              value={product_variant.allow_no_pickup_point}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "allow_no_pickup_point")}
              label={I18n.humanAttributeName("product_variant", "allow_no_pickup_point")}
              toggle
              readOnly={readOnlyAccess}
            />

            <FormControl.TextAreaFormGroup
              {...FormControl.addProps(`${name}.additional_pickup_instructions`, { errors })}
              value={product_variant.getTranslation(editedLocale).additional_pickup_instructions}
              onBlur={onBlur}
              onChange={this.handleTranslationPropChange.bind(this, "additional_pickup_instructions")}
              label={I18n.humanAttributeName("product_variant", "additional_pickup_instructions")}
              placeholder={I18n.humanAttributeName("product_variant", "additional_pickup_instructions_placeholder")}
              autoHeight
              readOnly={readOnlyAccess}
            />
          </Grid.Column>
        </Grid>

        {!!editedPickupPoint && (
          <div className="u-marginTop">
            <ProductPickupPointFormSection
              key={editedPickupPoint.uuid}
              readOnlyAccess={readOnlyAccess}
              name={`${name}.product_pickup_points[${editedPickupPoint.uuid}]`}
              product_variant={product_variant}
              product_pickup_point={editedPickupPoint}
              product_price_currency={product_price_currency}
              editedLocale={editedLocale}
              errors={errors}
              onBlur={onBlur}
              onChange={this.handleProductPickupPointChange.bind(this)}
              onRemove={this.handleProductPickupPointRemove.bind(this, editedPickupPoint)}
              onClose={() => this.setState({ editedPickupPointUuid: null })}
            />
          </div>
        )}
      </div>
    );
  }
}

@connect(
  (state) => ({
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
      },
      dispatch
    )
)
export default class StepLocationForm extends React.PureComponent {
  state = {
    newProductLocation: ProductLocationDecorator.build({ _new: true }),
    activeIndex: 0,
  };

  handleOpenAccordion = (e, { index }) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleProductPropChange(prop, value) {
    const { product, updateProduct } = this.props;
    let nextProduct;
    if (prop === "pickup_points_assignation_type" && value === "assignation_per_person") {
      nextProduct = {
        ...product,
        [prop]: value,
        pickup_points_price_type: "price_per_person",
      };
    } else {
      nextProduct = {
        ...product,
        [prop]: value,
      };
    }
    updateProduct(nextProduct);
  }

  handleProductVariantsPropChange(prop, value) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      product_variants: product.product_variants.map((pv) => ({
        ...pv,
        [prop]: value,
      })),
    });
  }

  handleProductVariantChange(product_variant) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      product_variants: product.product_variants.map((x) => (x.uuid === product_variant.uuid ? product_variant : x)),
    });
  }

  handleProductLocationAdd(attributes = {}) {
    const { product, updateProduct } = this.props;
    const product_locations = product.product_locations.concat([
      ProductLocationDecorator.build({
        position: Math.max(0, ...product.product_locations.map((x) => x.position)) + 1,
        ...attributes,
      }),
    ]);
    updateProduct({
      ...product,
      product_locations,
    });
  }

  handleProductLocationChange(product_location) {
    const { product, updateProduct } = this.props;
    if (product_location._new) {
      if (product_location.location_lat && product_location.location_lng) {
        this.setState({
          newProductLocation: ProductLocationDecorator.build({ _new: true }),
        });
        this.handleProductLocationAdd({ ...product_location, _new: undefined });
      } else {
        this.setState({ newProductLocation: product_location });
      }
    } else {
      const product_locations = product.product_locations.map((x) =>
        x.uuid === product_location.uuid ? product_location : x
      );
      updateProduct({
        ...product,
        product_locations,
      });
    }
  }

  renderProductVariantPickupsFormSection(product_variant) {
    const { readOnlyAccess, product, editedLocale, errors, validate } = this.props;
    const onBlur = validate;

    return (
      <ProductVariantPickupsFormSection
        readOnlyAccess={readOnlyAccess}
        name={`product.product_variants[${product_variant.uuid}]`}
        errors={errors}
        product_variant={product_variant}
        product_price_currency={product.price_currency}
        editedLocale={editedLocale}
        onChange={this.handleProductVariantChange.bind(this)}
        onBlur={onBlur}
      />
    );
  }

  _isProductVariantValid(pv) {
    const { errors } = this.props;
    return errors.hasValidProp(`product.product_variants[${pv.uuid}].product_pickup_points`);
  }

  render() {
    const { readOnlyAccess, product, editedLocale, submitLoading, valid, errors, validate } = this.props;
    const { activeIndex } = this.state;
    const onBlur = validate;
    const isAccommodation = product.product_type === "accommodation";

    let editedProductLocations = product.product_locations.concat(
      readOnlyAccess ? [] : [this.state.newProductLocation]
    );
    editedProductLocations =
      isAccommodation && editedProductLocations.length ? [editedProductLocations[0]] : editedProductLocations;

    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            {!!errors.base && <FormMessage error={errors.base} />}

            <h2>{I18n.t("papp.products.EditProductView.StepLocation.locations_title")}</h2>

            {editedProductLocations.map((product_location, index) => (
              <ProductLocationFormSection
                key={product_location.uuid}
                readOnlyAccess={readOnlyAccess}
                name={`product.product_locations[${product_location.uuid}]`}
                errors={errors}
                index={index}
                product_location={product_location}
                editedLocale={editedLocale}
                onChange={this.handleProductLocationChange.bind(this)}
              />
            ))}

            {!isAccommodation && (
              <div>
                <h2>{I18n.t("papp.products.EditProductView.StepLocation.pickup_points_title")}</h2>

                <FormControl.CheckboxFormGroup
                  {...FormControl.addProps(`${name}.pickup_points_price_per_person`, { errors })}
                  value={product.pickup_points_price_type === "price_per_person"}
                  onBlur={onBlur}
                  onChange={(checked) =>
                    this.handleProductPropChange(
                      "pickup_points_price_type",
                      checked ? "price_per_person" : "price_per_order"
                    )
                  }
                  label={I18n.t("papp.products.EditProductView.StepLocation.pickup_points_price_per_person_label")}
                  toggle
                  readOnly={readOnlyAccess}
                  disabled={product.pickup_points_assignation_type === "assignation_per_person"}
                />

                <br />

                {product.product_variants.length === 1 &&
                  this.renderProductVariantPickupsFormSection(product.product_variants[0])}

                {product.product_variants.length > 1 && (
                  <Accordion styled fluid defaultActiveIndex={0}>
                    {product.product_variants.map((pv) => [
                      <Accordion.Title
                        className={classNames({
                          "title--error": !this._isProductVariantValid(pv),
                        })}
                        active={activeIndex === pv.uuid}
                        index={pv.uuid}
                        onClick={this.handleOpenAccordion}
                      >
                        {pv.name || I18n.t("papp.common.no_name")} <i className="icon dropdown"></i>
                      </Accordion.Title>,
                      <Accordion.Content active={activeIndex === pv.uuid}>
                        {this.renderProductVariantPickupsFormSection(pv)}
                      </Accordion.Content>,
                    ])}
                  </Accordion>
                )}
              </div>
            )}

            <button type="submit" disabled={submitLoading} hidden onClick={(e) => e.preventDefault()} />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint isAccommodation={isAccommodation} />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepLocation/StepLocationForm.jsx